<template>
  <div>
    <table-list
      @selected="selectedModelo"
      actions="select"
      ref="table-list"
      v-if="show_modelos"
    />
    <dados-contrapartida v-model="contrapartida" ref="dados" v-else />
  </div>
</template>

<script>
import _ from "lodash";
import { validationMixin } from "vuelidate";
import { requiredIf, required, decimal } from "vuelidate/lib/validators";

import TableList from "@/modules/contrapartidas/Components/TableList.vue";
import DadosContrapartida from "@/modules/contrapartidas/Components/Form/DadosContrapartida.vue";

export default {
  mixins: [validationMixin],
  components: { TableList, DadosContrapartida },
  props: {
    value: {},
    select_modelos: false,
  },
  data: () => ({
    show_modelos: false,
    contrapartida: {
      tipo_contrapartida: "",
      descricao: "",
      unidade: "R$",
      minima: 0,
      maxima: 0,
      modelo_id: null,
    },
    validFormContrapartida: false,
  }),
  validations: {
    contrapartida: {
      tipo_contrapartida: {
        required,
      },
      unidade: {
        required: requiredIf(function (model) {
          return model.tipo == "financeira" || model.tipo == "bens-servico";
        }),
      },
      minima: {
        required: requiredIf(function (model) {
          return model.tipo == 1;
        }),
        decimal,
      },
      maxima: {
        required: requiredIf(function (model) {
          return model.tipo == 1 || model.tipo == 2;
        }),
        decimal,
      },
      descricao: {
        required,
      },
    },
  },
  methods: {
    isValid() {
      this.validFormContrapartida = this.$refs.dados.isValid();
      return !!this.validFormContrapartida;
    },
    save() {
      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });

        return null;
      }
      return this.contrapartida;
    },
    getSelecionados() {
      const selecionados = this.$refs["table-list"]
        ? this.$refs["table-list"].selecionados
        : [];
      return selecionados;
    },
    selectedModelo(item) {
      this.contrapartida.tipo_contrapartida = item.tipo_contrapartida;
      this.contrapartida.descricao = item.descricao;
      this.contrapartida.unidade = item.unidade;
      this.contrapartida.minima = item.minima;
      this.contrapartida.maxima = item.maxima;
      this.contrapartida.modelo_id = item.id;
      this.show_modelos = false;
      this.$emit("selectedModelo");
    },
  },

  created() {
    if (this.value) {
      this.contrapartida = _.merge(this.contrapartida, this.value);
    }
    this.show_modelos = this.select_modelos;
  },
};
</script>
